// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--33bb1";
export var steam_caption = "footer-module--steam_caption--c7260";
export var us = "footer-module--us--550c2";